/* Knit Duo basket prompt: one-tap add of a suggested knit, then re-render the cart drawer (snippets/summer-polo-offer.liquid). */
(() => {
  if (window.__knitDuoBound) return;
  window.__knitDuoBound = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-knit-duo-add]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    const id = Number(button.dataset.knitDuoAdd);
    const drawer = document.querySelector('cart-drawer');
    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    try {
      const response = await fetch(`${addUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id, quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'add failed');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'knit-duo', productVariantId: id });
      }
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ id, sections: data.sections });
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('Knit Duo add failed', error);
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      if (button.dataset.fallbackUrl) window.location.href = button.dataset.fallbackUrl;
    }
  });
})();
